import styled from 'styled-components';

import { device } from '@/styles/helpers';

export interface ScSlideGridContainerProps {
  rows: number;
  cols: number;
}

export const ScSlideGridContainer = styled.div<ScSlideGridContainerProps>`
  display: grid;
  height: 100%;
  grid-template-rows: ${({ rows }) => `repeat(${rows}, 1fr)`};
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: 16px;

  @media (${device.mobileS}) {
    & > a div {
      & > .text {
        h2 {
          max-width: 146px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
`;
